import { DateTime } from 'luxon';
import { WeekDay } from 'src/app/core/services/extended-program-guide.service';
import getDateTimeWeekDay from './getDateTimeWeekDay';

/**
 * Finds the closest weekday to the given DateTime instance
 * @param date DateTime instance
 * @param weekDay Weekday that we want to find the closest to the given DateTime instance
 * @returns The closest weekday to the given DateTime instance
 */
export default function findClosestWeekDay(date: DateTime, weekDay: WeekDay) {
  while (date.weekday !== getDateTimeWeekDay(weekDay)) {
    date = date.plus({ days: 1 });
  }
  return date;
}
